import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { selectVoivodeship } from "../../../../slices/voivodeship/voivodeshipSlice";
import {
  VoivObjects,
  voivodeships as vvObject,
} from "../../../../stuffs/Voivodeships";
import { useMap } from "react-leaflet";

const InnerMap: React.FC = () => {
  const voivodeship = useSelector(selectVoivodeship);

  const exactVV: VoivObjects = vvObject.filter(
    (vv) => vv.value === voivodeship
  )[0];

  const map = useMap();

  useEffect(() => {
    if (!exactVV) return;

    map.setView(
      exactVV.coordinates,
      exactVV.zoom
    );
  }, [map, exactVV]);

  return null;
};

export default InnerMap;